module.exports = __webpack_public_path__ + "img/piyopen.000ee5f9.png";